var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_vm._t("banner-img"),_c('div',{staticClass:"bigSlogan"},[_vm._t("banner-bigSlogan")],2),_c('div',{staticClass:"slogan"},[_vm._t("banner-slogan")],2),_vm._t("banner-video"),_vm._t("banner-button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }